import { useCallback, useState } from "react";
import useAdminLoad, { payloadShapeError } from "../../../hooks/useAdminLoad";
import * as crmApi from "../api/crmApi";

/**
 * The practice's CRM settings (`GET/PUT /api/crm/settings`, owner-only, contract C2.05):
 * the numbers the CRM's automatic behaviour reads — when an Active client becomes Past,
 * when a pack counts as ending, when a client has gone quiet, when to ask for a review,
 * the marketing send cap, and whether a no-show uses up a pack session.
 *
 * `save(fields)` sends only the fields it is given (the server `$set`s named keys and
 * nothing else) and adopts the server's answer as the new state, so what the screen
 * shows after a save is what the CRM will actually use.
 */
export default function useCrmSettings() {
  const [settings, setSettings] = useState(null);
  const load = useCallback(async () => {
    const body = await crmApi.getCrmSettings();
    if (!body || typeof body !== "object" || typeof body.review_threshold !== "number") {
      throw payloadShapeError();
    }
    setSettings(body);
  }, []);
  const { loading, loadError, reload } = useAdminLoad(load);

  const save = useCallback(async (fields) => {
    const saved = await crmApi.updateCrmSettings(fields);
    setSettings(saved);
    return saved;
  }, []);

  return { settings, loading, loadError, reload, save };
}
